<h4 *ngIf="mostrar">Productos Relacionados</h4>
<div class="d-flex flex-wrap flex-row justify-content-start align-items-center">
  <app-producto-template *ngFor="let prod of productos" [producto]="prod" [logueado]="currentUser!=null" [usuario]="idUsuario" [clicodigo]="clicodigo"></app-producto-template>
</div>
